module.exports = __webpack_public_path__ + "img/c1d2a69.jpeg";